import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledContentCard } from "./ContentCard.styles.mjs.mjs";
export const ContentCard = React.forwardRef(({ children, ...restProps }, forwardRef) => {
    const rootProps = {
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    return (React.createElement(StyledContentCard, { ...rootProps, ref: forwardRef }, children));
});
ContentCard.displayName = 'ContentCard';
//# sourceMappingURL=ContentCard.mjs.mjs.map